import {AttachmentSize, CompanyState, CompanyType} from "@/helpers/constants";
import Model from "@/models/Model";

export default class CompanySimple extends Model {

	public state!: CompanyState;
	public type!: CompanyType;
	public name!: string;
	public hasAvatar!: boolean;
	public avatarTimestamp!: number | null;

	public static avatarUrlSmall(companySimple: CompanySimple | null): string | null {
		return this.avatarUrl(companySimple, AttachmentSize.s);
	}

	public static avatarUrlMedium(companySimple: CompanySimple | null): string | null {
		return this.avatarUrl(companySimple, AttachmentSize.m);
	}

	public static avatarUrlLarge(companySimple: CompanySimple | null): string | null {
		return this.avatarUrl(companySimple, AttachmentSize.l);
	}

	public static avatarUrlOriginal(companySimple: CompanySimple | null): string | null {
		return this.avatarUrl(companySimple, AttachmentSize.orig);
	}

	private static avatarUrl(companySimple: CompanySimple | null, size: AttachmentSize | null): string | null {
		if (null === companySimple) {
			return null;
		}
		if (!companySimple.hasAvatar) return null;
		return process.env.VUE_APP_API_BASE_URL + `company/${companySimple.id}/avatar?size=${size}&cache=${companySimple.avatarTimestamp}`;
	}

}
